import { LANGUAGE_MAP } from 'constant/language';
import { useMemo } from 'react';
import { ContractLang } from '../utils';

const DisputeInfo = ({
  contractLang,
  storeName,
}: {
  contractLang: ContractLang;
  storeName: string;
}) => {
  const disputeInfoEl = useMemo(() => {
    let text = '';
    if (contractLang === LANGUAGE_MAP.FR) {
      text = `-En cas de litige, ${storeName} se réserve le droit de décision finale.`;
    }

    if (contractLang === LANGUAGE_MAP.EN) {
      text = `-In event of any disputes, ${storeName} reserves the right of final decision.`;
    }

    if (contractLang === LANGUAGE_MAP.ZH_CN) {
      text = `-如有任何争议，${storeName}保留最终决定权`;
    }

    if (text) {
      return (
        <div className="border-l border-r px-2 py-2 border-b shrink-0">
          {text}
        </div>
      );
    }

    return null;
  }, [contractLang, storeName]);

  return disputeInfoEl;
};

export default DisputeInfo;
